import * as React from 'react';
const SearchableSelectEmpty = props => {
  return /*#__PURE__*/React.createElement("div", {
    className: "SearchableList-empty"
  }, props.children);
};
export default SearchableSelectEmpty;